exports.list = {
    path: '/item_inventory',
    name: 'item_inventory_list', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/item_inventory/List.vue"),
}
exports.show = {
    path: '/item_inventory/show/:id',
    name: 'item_inventory_show', 
        meta: {
            authRequired: true,
        },
    component: () => import("@/views/main/item_inventory/Show.vue"),
}